<div class="flex flex-col gap-1">
  <div class="grid grid-cols-2 gap-1">
    <span>{{ "Module.ObjectInformation.ObjectType" | transloco }}</span>
    <div class="w-full flex justify-end text-primary-accumin-black-50 text-p1b">
      {{
        "Properties.ObjectType.LongVersion." + (portfolioObject()?.ShortObjectInformation?.ObjectSubType | objectTypeFromSubtype)
          | transloco
      }}
    </div>
  </div>
  <div class="grid grid-cols-2 gap-1">
    <span>{{ "Module.ObjectInformation.ConstructionYear" | transloco }}</span>
    <div class="w-full flex justify-end text-primary-accumin-black-50 text-p1b">
      {{ portfolioObject()?.ShortObjectInformation?.ConstructionYear }}
    </div>
  </div>
  <div class="grid grid-cols-2 gap-1">
    <span>{{ "Module.ObjectInformation.LivingSpace" | transloco }}</span>
    <div class="w-full flex justify-end text-primary-accumin-black-50 text-p1b">
      {{ (portfolioObject()?.ShortObjectInformation?.LivingSpace | translocoDecimal) + " m²" }}
    </div>
  </div>
  <div class="grid grid-cols-2 gap-1">
    <span>{{ "Module.ObjectInformation.PlotSize" | transloco }}</span>
    <div class="w-full flex justify-end text-primary-accumin-black-50 text-p1b">
      {{ (portfolioObject()?.ShortObjectInformation?.PlotSize | translocoDecimal) + " m²" }}
    </div>
  </div>
</div>
